/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { WarningNotificationComponent } from '../../notification-components/system-notifications/warning-notification-component';
import { withNotificationComponent } from '../base';
import { SystemNotification } from './system-notification';

/**
 * Represents a warning notification.
 * Use this notification when you want to provide some additional information or hints to the user.
 * For the success or error scenarios, please use `SuccessNotification` or `ErrorNotification` instead.
 * This is one of the types of system notifications.
 */
@withNotificationComponent(WarningNotificationComponent)
export class WarningNotification extends SystemNotification { }